module.exports = __webpack_public_path__ + "img/logo_landscape_dark.67aac834.svg";